import vuetify from "@/main";
import EditEntry from '@/modules/time/EditEntry.vue';
import timeEntryModal from '@/modules/time/timeEntryModal.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $stateProvider.state('timeplanner', {
    url: "/timeplanner",
    template: require('./views/timeplanner.html'),
    controller: 'TimePlannerCtrl'
  }).state('timeplanner.edit', {
    track: "Time: Edit",
    url: "/edit/{entryId}",
    views: {
      'edit@timeplanner': {
        template: require('../time/views/edit.html'),
        controller: 'EntryEditCtrl'
      }
    }
  }).state('timeplanner.edit2', {
    track: "Time: Edit",
    url: "/edit2/{entryId}",
    views: {
      'edit@timeplanner': {
        ...vuetify(timeEntryModal)
      }
    }
  }).state('timeplanner.new', {
    track: "Time: Create",
    url: "/new",
    params: {
      entry: null,
      item: null,
      expanded: null,
      timerId: null
    },
    views: {
      'edit@timeplanner': {
        template: require('../time/views/edit.html'),
        controller: 'EntryEditCtrl'
      }
    }
  }).state('timeplanner.new2', {
    track: "Time: Create",
    url: "/new2",
    params: {
      entry: null,
      item: null,
      expanded: null,
      timerId: null
    },
    views: {
      'edit@timeplanner': {
        ...vuetify(timeEntryModal)
      }
    }
  }).state('timeplanner.new.matter', {
    track: "Matter: Create",
    url: "/matter",
    params: {
      clientId: null
    },
    views: {
      'edit': {
        template: require('../matters/views/create.html'),
        controller: 'MattersCreateCtrl'
      }
    }
  }).state('timeplanner.new.matter.client', {
    //Client create pop-up
    track: "Client: Create",
    url: "/client",
    params: {
      popup: true
    },
    views: {
      'edit': {
        template: require('../matters/views/client-popup.html')
      },
      //nested view
      'popup@timeplanner.new.matter.client': {
        template: require('../matters/views/client.html'),
        controller: 'ClientEditCtrl'
      }
    }
  });
}]);